import Button from "components/Button";
import ImageSlider from "components/ImageSlider";
import Text from "components/Text";
import TextInput from "components/TextInput";
import { config } from "config";
import { memo } from "react";
import theme from "theme";
import * as Styled from "../shared";
import { useResetPassword } from "./useResetPassword";

const ResetPassword = memo(() => {
    const {
        handleInputChange,
        inputErrors,
        inputs,
        isLoading,
        handleResetPassword,
    } = useResetPassword();
    return (
        <Styled.Wrapper>
            <Styled.LeftWrapper>
                <Styled.Card>
                    <Text variant="heading5" align="center" fullWidth>
                        Reset Password
                    </Text>
                    <Styled.Form onSubmit={handleResetPassword}>
                        <TextInput
                            name="password"
                            type="password"
                            label="New Password"
                            required
                            placeholder="********"
                            fullWidth
                            labelColor={theme.colors.text}
                            value={inputs.password}
                            onChange={handleInputChange}
                            errorMsg={inputErrors.password}
                        />
                        <TextInput
                            name="confirmPassword"
                            type="password"
                            label="Confirm New Password"
                            required
                            placeholder="********"
                            fullWidth
                            labelColor={theme.colors.text}
                            value={inputs.confirmPassword}
                            onChange={handleInputChange}
                            errorMsg={inputErrors.confirmPassword}
                        />
                        <Button
                            type="submit"
                            variant="filled"
                            fullWidth
                            textColor={theme.colors.white}
                            textVariant="button2"
                            isLoading={isLoading}
                        >
                            Reset Password
                        </Button>
                    </Styled.Form>
                </Styled.Card>
            </Styled.LeftWrapper>
            <Styled.RightWrapper>
                <ImageSlider sliderImages={config.sliderImages} />
            </Styled.RightWrapper>
        </Styled.Wrapper>
    );
});

export default ResetPassword;
